/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2022 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
/**
 * Grid Item styles
 *
 * @file GridItemStyles.js
 * @author Mohamed Yasar arabath M
 * @since 0.0.2
 */

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledGridItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'colspan'
})(({ colspan }) => {
  const spanning = (typeof colspan === 'number' && colspan) || 1;

  return {
    '&&': {
      gridColumn: `span ${spanning}`
    }
  };
});

export default StyledGridItem;
